import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import moment from 'moment';
import {
    changeCurrentPath,
    fetchShipmentData,
    setShipmentState,
    resetShipmentState,
    updateShipmentFlag,
    fetchShipmentRotationNO,
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ErrorDialog from "../../common/components/dialog/error-dialog";
import ReloadModal from "../../common/components/dialog/reload-dialog";
import LogoutModal from "../../common/components/dialog/logout-dialog";
import AlertDialog from "../../common/components/dialog/alert-dialog";

import MainButtons from '../../common/components/main-buttons';
import Tables from '../../common/components/table/common-table';
import Select from '../../common/components/input/control-suggest-select';

import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import FormGroup from "@material-ui/core/FormGroup";
import {DatePicker} from "material-ui-pickers";
import Divider from "@material-ui/core/Divider";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import FormHelperText from '@material-ui/core/FormHelperText';

const columns = [
    { name: 'OtodokesakiName', title: '納品先名称' ,width:250},
    { name: 'OtodokesakiAddress', title: '納品先住所' ,width:250},
    { name: 'NinushiName', title: '荷主名' ,width:250},
    { name: 'DenpyoMaisu', title: '伝票枚数' ,width:130, align:'right'},
    { name: 'RegisterMaisu', title: '登録済伝票' ,width:130, align:'right'}
    ];

const numberColumns = ['RegisterMaisu','DenpyoMaisu'];

const styles = theme => ({
    datePicker : {
        marginTop : 4,
        marginRight:30,
        paddingRight:30,
        borderRight:'rgba(0,0,0,0.1) solid 1px',
        width:'150px'
    },
    ExpansionPanelDetails : {
        flexDirection : 'column'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontFamily:'Noto Sans JP'
    },
    expands : {
        boxShadow:'initial'
    },
    shipmentInputSyaban: {
        margin: '0 40px 0 0',
        width: '150px',
    },
    shipmentInputKaiten: {
        borderStyle: 'dashed',
        width: '150px',
    },
    extractionFormGroup: {
        display: 'flex',
        alignItems: 'flex-start',
        margin: '0 0 5px 0',
    },
    extractionForm: {
        margin: '4px 16px 0 0',
        width: 'calc(150px + 1em)',
    },
    extractionFormGroupRegister: {
        marginBottom:-35,
        padding:'10px 40px 10px 20px',
        border:'solid rgba(0,0,0,0.1) 1px',
        borderRadius:5,
        display:'inline-block',
        position:'relative'
    },
    extractionFormGroupLabel:{
        position:'absolute',
        top:-13,
        left:15,
        paddingLeft:5,
        paddingRight:5,
        backgroundColor:'#FFFFFF',
        color:'rgba(0,0,0,0.67)'

    },
    selectWrap:{
        width: '150px',
    },
    selectHelperText:{
        width:'200%'
    }
});


class Shipment extends Component {

    constructor(props) {
        super(props);
        const {settings} = props;
        const {deliveryDate, extractCarNumber, extractRotationNO} = settings;
        this.state = {
            deliveryDate,
            extractCarNumber,
            extractCarNumberDefValue : null,
            extractRotationNO,

            onFetchRotationNo:false,

            dialogOpen : false,
            cancelDialogOpen: false,
            afterCancelProcess : undefined
        };
        this.nextIsDetail = false;
    }
    /** override methods **/
    componentDidMount() {
        const { dispatch, history } = this.props;
        window.scrollTo(0, 0);
        dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
    }
    componentWillUnmount(){
        const { dispatch} = this.props;
        if(!this.nextIsDetail){
            dispatch(resetShipmentState());
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.settings.isCompleteUpdate){
            this.doClear();
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if(prevState.onFetchRotationNo && nextProps.settings.rotationNoData.length > 0){
            return{
                extractRotationNO:nextProps.settings.rotationNoData[0],
                onFetchRotationNo:false
            }
        }
        return null;
    }

    /** event handlers **/
    handleDeliveryDateChange = deliveryDate => {
        this.setState({
            deliveryDate
        }, this.fetchRotationNoData);
    };
    handleDeliveryDateInputChange = event =>{
        if(!event.target.value) this.setState({ deliveryDate: null });
    }
    handleExtractCarNumberChange = event =>{
        this.setState({extractCarNumber:event.target.value});
    }
    handleExtractCarNumberFocus = event =>{
        this.setState({extractCarNumberDefValue : event.target.value})
    }
    handleExtractCarNumberBlur = () =>{
        const {extractCarNumber,extractCarNumberDefValue} = this.state;
        const {dispatch} = this.props;
        if(extractCarNumber === extractCarNumberDefValue){
            //Focus時とBlur時の値が一致していれば何もしない
            this.setState({
                extractCarNumberDefValue : null
            });
            return;
        }
        if(!extractCarNumber){
            dispatch(setShipmentState({
                rotationNoData : [],
                rotationNoDataIsError:false
            }));
            this.setState({
                extractRotationNO:null,
                extractCarNumberDefValue : null
            });
            return;
        }
        this.fetchRotationNoData();
    }
    handleChangeExtractRotationNO = extractRotationNO =>{
        this.setState({ extractRotationNO })
    }
    handleSelectionChange = selections => {
        this.props.dispatch(setShipmentState({selections}));
    };
    handleSortOrderChange = (sorts) =>{
        this.props.dispatch(setShipmentState({sorts}));
    };
    handleFilterChange = (filters) =>{
        this.props.dispatch(setShipmentState({filters}));
    };
    handleClickSumup = () => {
        if(!this.getIsRegisterDisabled()){
            this.setState({
                cancelDialogOpen: true,
                afterCancelProcess:this.doSumup
            })
        }
        else{
            this.doSumup();
        }
    };
    doSumup = () =>{
        const {dispatch,auth} = this.props;
        const {deliveryDate, extractCarNumber, extractRotationNO} = this.state;
        dispatch(fetchShipmentData({
            carNumber: extractCarNumber,
            deliveryDate : !(deliveryDate) ? null : deliveryDate.format('YYYY-MM-DD'),
            rotationNO: !(extractRotationNO)? null : extractRotationNO.value,
            SessionID : auth.SessionID
        }));
    }
    handleInputCarNumberChange = event =>{
        this.props.dispatch(setShipmentState({inputCarNumber:event.target.value}));
    }
    handleInputRotationNOChange = event =>{
        this.props.dispatch(setShipmentState({inputRotationNO:event.target.value}));
    }
    handleClickDetail = event => {
        const {history, dispatch} = this.props;
        const {deliveryDate, extractCarNumber, extractRotationNO} = this.state;
        this.nextIsDetail = true;
        dispatch(setShipmentState({
            deliveryDate, extractCarNumber, extractRotationNO
        }));
        history.push('/shipment-detail');
    };

    fetchRotationNoData = () =>{
        const {dispatch,auth} = this.props;
        const {deliveryDate, extractCarNumber} = this.state;
        if(!deliveryDate || !extractCarNumber) return;

        this.setState({
            extractRotationNO : null,
            onFetchRotationNo : true
        })

        dispatch(fetchShipmentRotationNO({
            deliveryDate : !(deliveryDate) ? null : moment(deliveryDate).format('YYYY-MM-DD'),
            carNumber : extractCarNumber,
            SessionID : auth.SessionID
        }));
    }

    handleClickRegister = event => {
        this.setState({
            dialogOpen : true
        });
    };
    handleDoRegister = event => {
        this.setState({
            dialogOpen:false
        });
        const {dispatch, auth, settings} = this.props;
        const {selections,inputCarNumber,inputRotationNO} = settings;
        const paramSelections = selections.map(selection=>{
            return selection["id"];
        });
        dispatch(updateShipmentFlag({
            SessionID : auth.SessionID,
            headerIDs: paramSelections,
            carNumber: inputCarNumber,
            rotationNO: inputRotationNO === "" ? null : inputRotationNO
        }));
    }
    handleCancelRegister = () =>{
        this.setState({
            dialogOpen:false
        });
    };

    handleClickClear = () =>{
        if(!this.getIsRegisterDisabled()){
            this.setState({
                cancelDialogOpen: true,
                afterCancelProcess:this.doClear
            })
        }
        else{
            this.doClear();
        }
    }
    handleCancelProcess = () =>{
        this.setState({
            cancelDialogOpen:false,
            afterCancelProcess:undefined
        })
    }
    handleDoProcess = () =>{
        this.setState({
            cancelDialogOpen:false
        })
        this.state.afterCancelProcess();
    }
    doClear = () =>{
        const {dispatch} = this.props;
        dispatch(resetShipmentState());
        this.setState({
            deliveryDate:moment(),
            extractCarNumber:'',
            extractCarNumberDefValue : null,
            extractRotationNO:null,
            dialogOpen : false,
            cancelDialogOpen: false,
        });
    }
    handleClickUpload = () =>{
        if(!this.getIsRegisterDisabled()){
            this.setState({
                cancelDialogOpen: true,
                afterCancelProcess:this.goUpload
            })
        }
        else{
            this.goUpload();
        }
    }
    goUpload = () =>{
        this.props.history.push('/upload/2');
    }




    getIsRegisterDisabled = () =>{

        const {data,
            inputCarNumber,bufInputCarNumber,inputRotationNO,bufInputRotationNO,
            isDetailsUpdate,selections
        } = this.props.settings;
        //入力が更新されたかどうか
        const isInputUpdate = (bufInputCarNumber !== inputCarNumber || String(bufInputRotationNO) !== String(inputRotationNO));

        let isMainListUpdate = false;
        if(bufInputCarNumber){
            //編集モードの時に更新されたか
            isMainListUpdate = (selections.length !== data.length || isInputUpdate || isDetailsUpdate)
        }
        else{
            //編集モードの時に更新されたか
            isMainListUpdate = selections.length > 0;
        }

        return !inputCarNumber || data.length === 0 || !isMainListUpdate;
    }


    render() {
        const { classes, settings, history } = this.props;
        const {
            isFetching,
            data,
            selections,filters,sorts,
            inputCarNumber,inputRotationNO,
            rotationNoData,
            rotationNoDataIsError
        } = settings;

        const {
            deliveryDate, extractCarNumber, extractRotationNO,
            dialogOpen,cancelDialogOpen
        } = this.state;

        const detailDisabled = !(selections && selections.length > 0);

        const isExtractRotationNoDisabled = Boolean(rotationNoData.length === 0);
        const isSumupDisabled = Boolean(!(deliveryDate)) || (Boolean(extractCarNumber) && isExtractRotationNoDisabled);
        const isInputDisabled = Boolean(data.length === 0);


        const mainButtons = [
            {type:'NEXT',func:this.handleClickDetail,text:"明細",disabled:detailDisabled},
            {type:'SAVE',func:this.handleClickRegister,text:"登録",disabled: this.getIsRegisterDisabled(), hasMargin:true},
            {type:'CLEAR',func:this.handleClickClear,text:"クリア"},
            {type:'UPLOAD',func:this.handleClickUpload,hasMargin:true},
        ];



        return (
            <div id="main_container">
                {isFetching &&
                <Progress/>
                }
                <SpNav history={history}/>
                <Header history={history}/>
                <article>
                    <section className="title_area">
                        <h2>車番登録</h2>
                    </section>
                    <ExpansionPanel defaultExpanded className={classNames("with_button condition_area",classes.expands)}>
                        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                            <Typography className={classes.heading}>抽出条件</Typography>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails
                            className={classes.ExpansionPanelDetails}
                        >
                            <FormGroup
                                row
                                className={classes.extractionFormGroup}
                            >
                                <DatePicker
                                    keyboard
                                    label="納品日"
                                    value={deliveryDate}
                                    onChange={this.handleDeliveryDateChange}
                                    onInputChange={this.handleDeliveryDateInputChange}
                                    format="YYYY/MM/DD"
                                    className={classes.datePicker}
                                    invalidDateMessage="日付が正しくありません"
                                    cancelLabel={"キャンセル"}
                                />
                                <TextField
                                    label="車番"
                                    className={classes.extractionForm}
                                    onChange={this.handleExtractCarNumberChange}
                                    onFocus={this.handleExtractCarNumberFocus}
                                    onBlur={this.handleExtractCarNumberBlur}
                                    inputProps={{
                                        placeholder: '',
                                        maxLength:4,
                                    }}
                                    value={extractCarNumber}
                                />
                                <div className={classes.selectWrap}>
                                    <Select
                                        inputLabel="回転"
                                        className={classes.extractionForm}
                                        suggestions={rotationNoData}
                                        value={extractRotationNO}
                                        afterChangeFunction={this.handleChangeExtractRotationNO}
                                        disabled={isExtractRotationNoDisabled}
                                        isClearable={false}
                                    />
                                    {rotationNoDataIsError &&
                                    <FormHelperText className={classes.selectHelperText}
                                                    error>条件に該当する回転が登録されていません</FormHelperText>
                                    }
                                </div>

                            </FormGroup>
                        </ExpansionPanelDetails>
                        <Divider />
                        <ExpansionPanelActions>
                            <Button variant="contained" color="primary" size="large" onClick={this.handleClickSumup} disabled={isSumupDisabled}>
                                集計
                            </Button>
                        </ExpansionPanelActions>
                    </ExpansionPanel>
                    <section className="with_button">
                        <FormGroup
                            row
                            className={classes.extractionFormGroupRegister}
                        >
                            <label className={classes.extractionFormGroupLabel}>設定値</label>
                            <TextField
                                label="車番"
                                className={classes.shipmentInputSyaban}
                                inputProps={{
                                    name: 'Syaban',
                                    placeholder: '',
                                    maxLength:4,
                                }}
                                onChange={this.handleInputCarNumberChange}
                                value={inputCarNumber}
                                disabled={isInputDisabled}
                            />
                            <TextField
                                label="回転"
                                className={classes.shipmentInputKaiten}
                                inputProps={{
                                    name: 'Kaiten',
                                    placeholder: '',
                                    maxLength:2
                                }}
                                onChange={this.handleInputRotationNOChange}
                                value={inputRotationNO}
                                disabled={isInputDisabled}
                            />
                        </FormGroup>
                        <Tables
                            dataSource={data}
                            columns={columns}
                            selections={selections}
                            filters={filters}
                            numberColumns={numberColumns}
                            getSelections={this.handleSelectionChange}
                            getSortOrders={this.handleSortOrderChange}
                            getFilters={this.handleFilterChange}
                            defaultSorts={sorts}
                        />
                    </section>
                </article>
                <MainButtons buttons={mainButtons}/>
                <Footer/>
                <AlertDialog
                    open={dialogOpen}
                    title={"確認"}
                    text={<span>車番と回転と配送順を登録します。</span>}
                    okFunction={this.handleDoRegister}
                    closeFunction={this.handleCancelRegister}
                />
                <ErrorDialog
                    open={settings.isProcessError}
                />
                <AlertDialog
                    open={cancelDialogOpen}
                    title={"確認"}
                    text={<span>編集中のデータは破棄されます。<br/>よろしいですか？</span>}
                    okFunction={this.handleDoProcess}
                    closeFunction={this.handleCancelProcess}
                />
                <ReloadModal />
                <LogoutModal />
            </div>
        )
    }
}
function mapStateToProps(state) {
    return {
        navigation : state.navigation,
        auth: state.auth,
        settings : state.shipmentSettings,
        detailSettings : state.shipmentDetailSettings
    };
}

export default compose(
    withStyles(styles),
    connect(mapStateToProps)
)(Shipment);



// WEBPACK FOOTER //
// ./src/routes/shipment/index.js